import { generateTestId } from "@client-shared";

export const setProductSyncModalTestId = (identifier: string): string => generateTestId("ProductSyncModal", identifier);

export const setProductSyncFooterCountTestId = (identifier: string): string => generateTestId("ProductSyncModalFooterCount", identifier);

export const setProductSyncParentChildDisplayTestId = (productId: string): string =>
  generateTestId("product-sync-parent-child-display", productId);

export const setAccordionTriggerTestId = (productId: string, bagSize: string): string => {
  const testId = `${productId}-bag-size-row`;
  return generateTestId(testId, "accordion-trigger", bagSize);
};

export const setAccordionTriggerBagSizeTitleTestId = (productId: string, bagSize: string): string => {
  const testId = `${productId}-bag-size-row`;
  return generateTestId(testId, "accordion-trigger-bag-size-title", bagSize);
};

export const setAccordionTriggerWebStatusTestId = (productId: string, bagSize: string): string => {
  const testId = `${productId}-bag-size-row`;
  return generateTestId(testId, "accordion-trigger-web-status", bagSize);
};

export const setRowLabelTitleTestId = (productId: string, bagSize: string) => {
  const testId = `${productId}-bag-size-row`;
  return generateTestId(testId, "label-title", bagSize);
};

export const setRowMappingInfoTestId = (productId: string, bagSize: string) => {
  const testId = `${productId}-bag-size-row`;
  return generateTestId(testId, "mapping-info", bagSize);
};

export const setSelectVariantTestId = (productId: string, bagSize: string) => {
  const testId = `${productId}-select-bag-size`;
  return generateTestId(testId, "select-variant", bagSize);
};

export const setVariantRowPlaceholderTestId = (productId: string, bagSize: string) => {
  const testId = `${productId}-variant-row-placeholder`;
  return generateTestId(testId, "variant-row-placeholder", bagSize);
};

export const setVariantRowTestId = (targetVariantId: string): string => generateTestId("variant-row", "single", targetVariantId);

export const setSingleVariantRowProductNameTestId = (targetVariantId: string): string =>
  generateTestId("single-variant-row-product-name", "single-variant-row-product-name", targetVariantId);

export const setSingleVariantRowVariantNameTestId = (targetVariantId: string): string =>
  generateTestId("single-variant-row-variant-name", "single-variant-row-variant-name", targetVariantId);

export const setOverrideButtonTestId = (targetVariantId: string): string => generateTestId("override-button", "single", targetVariantId);

export const setVariantRowGrindCheckboxTestId = (targetVariantId: string, grindType: string): string =>
  generateTestId("variant-row-grind-checkbox", targetVariantId, grindType.split(" ").join("-"));

export const setVariantRowGrindsLayoutTestId = (targetVariantId: string): string =>
  generateTestId("variant-row-grinds-layout", "single", targetVariantId);

/** Shared prefix of every store-product MultiSelect identifier, so selectors can match any row */
export const REMOTE_VARIANT_MULTI_SELECT_PREFIX = "remote-variant-";

export const getRemoteVariantMultiSelectIdentifier = (localVariantId: string, bagSize: string): string =>
  `${REMOTE_VARIANT_MULTI_SELECT_PREFIX}${localVariantId}-${bagSize.replace(/\s+/g, "-").toLowerCase()}`;
